module.exports = __webpack_public_path__ + "img/process5.23a2af38.png";